var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonCaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.990234,
    y: 1.20422,
    width: 20.5,
    height: 14.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5728_64463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.990234,
    y: 1.20422,
    width: 20.5,
    height: 14.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5728_64463)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.7402,
    y: 0.954224,
    width: 6,
    height: 15,
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.740234 15.9542H6.74023V0.954224H0.740234V15.9542Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0078 7.68663C12.7779 7.91658 12.3894 7.70864 12.4531 7.38976L12.7402 5.95422L11.7402 6.45422L11.2402 4.95422L10.7402 6.45422L9.74023 5.95422L10.0273 7.38976C10.0911 7.70864 9.70259 7.91658 9.47264 7.68663C9.34429 7.55828 9.13618 7.55828 9.00783 7.68663L8.74023 7.95422L7.74023 7.45422L8.24023 8.45422L7.97594 8.71852C7.84576 8.8487 7.84576 9.05975 7.97594 9.18993L9.24023 10.4542H10.7402L10.9902 11.9542H11.4902L11.7402 10.4542H13.2402L14.5045 9.18993C14.6347 9.05975 14.6347 8.8487 14.5045 8.71852L14.2402 8.45422L14.7402 7.45422L13.7402 7.95422L13.4726 7.68663C13.3443 7.55828 13.1362 7.55828 13.0078 7.68663Z",
    fill: "#FF3131"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonCaIcon);
export default __webpack_public_path__ + "static/media/amazon-ca-icon.504cb3f672a3d1c434627316e26a8837.svg";
export { ForwardRef as ReactComponent };